const initialState = {
  loading: false,
  authId: null,
  password: null,
  errorAuthId: null,
  errorPasswordReset: null,
};

const romPasswordReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case 'GET_ROM_AUTH_ID_REQUEST': {
      return {
        ...state,
        loading: true,
        password: null,
      };
    }
    case 'GET_ROM_AUTH_ID_SUCCESS': {
      return {
        ...state,
        loading: false,
        authId: action.payload.auth_id,
      };
    }
    case 'GET_ROM_AUTH_ID_FAILURE': {
      return {
        ...state,
        loading: false,
        errorAuthId: action.status,
      };
    }
    case 'RESET_ROM_PASSWORD_REQUEST': {
      return {
        ...state,
        loading: true,
      };
    }
    case 'RESET_ROM_PASSWORD_SUCCESS': {
      return {
        ...state,
        loading: false,
        password: action.payload.password,
      };
    }
    case 'RESET_ROM_PASSWORD_FAILURE': {
      return {
        ...state,
        loading: false,
        errorPasswordReset: action.status,
      };
    }
    default:
      return state;
  }
};

export default romPasswordReducer;
